import { create } from 'zustand';

interface IDeviceRisk {
  blackbox: any;
  setBlackbox: (newState: any) => void;
}

export const useDeviceRisk = create<IDeviceRisk>(set => ({
  blackbox: undefined,
  setBlackbox: blackbox => set(() => ({ blackbox }))
}));
